import { cva } from 'class-variance-authority';
export const getChipClasses = cva('inline-flex select-none max-w-full items-center border transition-colors duration-150', {
    variants: {
        disabled: { false: 'cursor-pointer', true: 'cursor-default opacity-50' },
        rounded: { false: 'rounded-md', true: 'rounded-full' },
        size: { md: 'h-8 text-sm', sm: 'h-6 text-xs' },
        variant: { neutral: '', suggestion: '' },
        visuallySelected: { false: '', true: '' },
        leadingAccessory: { false: '', true: 'gap-1' },
    },
    compoundVariants: [
        { size: 'md', leadingAccessory: false, class: 'px-3' },
        { size: 'md', leadingAccessory: true, class: 'pl-2 pr-3' },
        { size: 'sm', leadingAccessory: false, class: 'px-2' },
        { size: 'sm', leadingAccessory: true, class: 'pl-1 pr-2' },
        { visuallySelected: false, variant: 'neutral', class: 'border-soft bg-subtle' },
        { visuallySelected: false, disabled: false, variant: 'neutral', class: 'hover:bg-subtle' },
        {
            visuallySelected: true,
            variant: 'neutral',
            class: 'bg-inverse text-inverse border-transparent',
        },
        { visuallySelected: true, disabled: false, variant: 'neutral', class: 'hover:opacity-85' },
        {
            variant: 'suggestion',
            visuallySelected: false,
            class: 'border-dashed bg-transparent border-base',
        },
        { variant: 'suggestion', visuallySelected: false, disabled: false, class: 'hover:bg-subtle' },
        {
            variant: 'suggestion',
            visuallySelected: true,
            class: 'bg-soft border-transparent text-primary',
        },
    ],
    defaultVariants: {
        disabled: false,
        rounded: false,
        size: 'md',
        variant: 'neutral',
        visuallySelected: false,
        leadingAccessory: false,
    },
});
//# sourceMappingURL=classes.js.map